var _rect, _circle, _path, _rect2, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame108(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 76,
    viewBox: "0 0 94 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.6338,
    y: 11.9717,
    width: 20.7957,
    height: 20.7957,
    transform: "rotate(12.2865 42.6338 11.9717)",
    fill: "#87D5CC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65.868,
    cy: 55.6756,
    r: 11.7317,
    transform: "rotate(32.5356 65.868 55.6756)",
    fill: "#E0B598"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6459 63.1427L10.7888 64.0062L23.9696 39.4494L38.6459 63.1427Z",
    fill: "#567793"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.6333,
    y: 15.799,
    width: 19.6497,
    height: 19.6497,
    transform: "rotate(12.2865 39.6333 15.799)",
    stroke: "black",
    strokeWidth: 1.14603
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.284,
    cy: 57.4744,
    r: 11.1586,
    transform: "rotate(32.5356 61.284 57.4744)",
    stroke: "black",
    strokeWidth: 1.14603
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6437 42.6789L42.2748 64.6847L16.4017 65.4867L28.6437 42.6789Z",
    stroke: "black",
    strokeWidth: 1.14603
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame108);
export default __webpack_public_path__ + "static/media/Frame108.13b448849b70055c97f993e69575039f.svg";
export { ForwardRef as ReactComponent };